import { Component, OnInit, Input, HostListener, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SignupService } from "../../../shared/components/modal/signup-modal/signup-modal.service";
import { HeaderOneService } from 'src/app/shared/header/header-one/header-one.service';
import { HomeService } from 'src/app/home/home.service';
import { ToasterService } from 'src/app/helpers/toastr.service';
import { BuyerAssistanceService } from '../../buyer-assistance/buyer-assistance.service';

@Component({
  selector: 'app-header-buyer',
  templateUrl: './header-buyer.component.html',
  styleUrls: ['./header-buyer.component.scss']
})
export class HeaderBuyerComponent implements OnInit {

    @Input() class: string;
    @Input() themeLogo: string = 'assets/images/icon/logo.png'; // Default Logo
    @Input() topbar: boolean = true; // Default True
    @Input() sticky: boolean = false; // Default false

    public stick: boolean = false;
    public token:string;
    public usertype:string;
    public name:string;
    public wallet_amount:string;
    public cart_count:number;
    public profile_image:string;

    public assistance_records:any = [];

    constructor(
        public route: Router,
        public _router:ActivatedRoute,
        public _signupservice: SignupService,
        public _headerservice: HeaderOneService,
        public _homeservice: HomeService,
        public _toastr: ToasterService,
        private _buyerassistanceservice: BuyerAssistanceService,
        private _singupservice: SignupService
    ) { }

    ngOnInit(){
        this.token = this._signupservice.gettoken();
        this._signupservice.tokenChanged.subscribe((response: string) => {
            this.token = this._signupservice.gettoken();
        });

        this.token = this._signupservice.gettoken();
        this.usertype = this._signupservice.getusertype();
        this._signupservice.tokenChanged.subscribe((response: string) => {
            this.token = response;
        });
        setTimeout(()=>{

        }, 500);
        if(this.token){
            this.getuserdetails();
        }

        //Assitance Details
        this.assistance_records = this._singupservice.getbuyerassistance();
        this._singupservice.buyerAssistanceChanged.subscribe((response: string) => {
            this.assistance_records = response;
        });

        if(!this.assistance_records || this.assistance_records.length == 0){
            this.getassistances();
        }
            
    }

    getassistances() {
        this._buyerassistanceservice.getassistances({user_type:'both'}).subscribe((data) => {
            if(data['status'] == "success"){
                this.assistance_records = data['records'];
                let assistance_array = [];
                for (var i = 0; i < this.assistance_records.length; i++) {
                    assistance_array.push({title: this.assistance_records[i].title, id: this.assistance_records[i].id});
                }
                this._singupservice.updateassistance(assistance_array);
            }
        },(error) => {
        });
    }

    result = [];
    keyword = 'name';
    public search_value: string;
    public limit = 20;
    public offset = 0;
    public current_page = 1;
    selectEvent(item) {
        var slug = item.parent;
        if(item.from == 'product'){
            slug = item.slug;
        }else if(item.from == 'category'){
            slug = item.name;
        }
        this.route.navigate(['/search'], { queryParams: { q: slug, limit: this.limit, offset: this.offset, current_page: this.current_page } });
        // this.route.navigate(['/search'], { queryParams: { q: item.parent, limit: this.limit, offset: this.offset, current_page: this.current_page } });
        // do something with selected item
    }

    onChangeSearch(val: string) {
        this.search_value = val;
        // fetch remote data from here
        // And reassign the 'data' which is binded to 'data' property.
        this._homeservice.searchcategory({ search: val }).subscribe((data) => {
            if (data['status'] == "success") {
                this.result = data['records'];
            } else if (data['status'] == "error") {
                this._toastr.error(data['message']);
            }
        });
    }

    submitsearch(event) {
        this.route.navigate(['/search'], { queryParams: { q: this.search_value, limit: this.limit, offset: this.offset, current_page: this.current_page } });
    }

    onFocused(e) {
        // do something when input is focused
    }

    getuserdetails() {
        this._headerservice.getuserdetails(null).subscribe((data) => {
            if(data['status'] == "success"){
                this._signupservice.updatestatus(data['data']['adminverified']);
                this._signupservice.updateregstatus(data['data']['reg_status']);
                this.name = data['data']['name']
                this.wallet_amount = data['data']['walletbalance']
                this.cart_count = data['data']['cart_count'];
                this.profile_image = data['data']['profile_image'];
            }
        },(error) => {

        });
    }
        

    // @HostListener Decorator
    @HostListener("window:scroll", [])
    onWindowScroll() {
        let number = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  	    if (number >= 150 && window.innerWidth > 400) { 
  	        this.stick = true;
  	    } else {
  	        this.stick = false;
  	    }
    }

    logout(){
        this._signupservice.logout();
        this.route.navigate(['/home']);
    }

}
